// The foot of the three Fly legal pages: a way home, then the other two policies, so a
// reader who lands on one can reach the rest (impeccable polish, 17 Oct 26).
import { Link } from 'react-router-dom';

export const LEGAL_PAGES = [
  { to: '/terms-of-service', label: 'Terms of Service' },
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/cookie-policy', label: 'Cookie Policy' },
] as const;

export const LegalPageLinks = ({ current }: { current: (typeof LEGAL_PAGES)[number]['to'] }) => (
  <nav aria-label="Legal" className="mt-12 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-slate-200 pt-6 text-sm">
    <Link to="/" className="font-medium text-violet-700 hover:underline">
      Back to home
    </Link>
    {LEGAL_PAGES.filter((page) => page.to !== current).map((page) => (
      <Link key={page.to} to={page.to} className="text-slate-600 hover:text-violet-700 hover:underline">
        {page.label}
      </Link>
    ))}
  </nav>
);
